import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PaymentAccountListItem } from '@/models/dictionary/payment-account-list.model';

export default class GetPaymentAccountListRequest extends ApiResourceMethod<PaymentAccountListItem[]> {
  public perform(wlSlug: string): Promise<PaymentAccountListItem[]> {
    return this.performer.requestWithMapper(
      {
        url: `${wlSlug}/dictionary/paymentAccount`,
      },
      (payload: BaseResponse<PaymentAccountListItem[]>) => {
        return payload.data;
      },
    );
  }
}
